export const SET_GURUS = (state, guru) => {
    state.gurusData = guru;
}

export const SET_GURUS_PERSEKOLAH = (state, gurusPersekolah) => {
    state.gurusPersekolahData = gurusPersekolah;
}

export const SET_GURUS_QUEUE_PERSEKOLAH = (state, payload) => {
    state.gurusQueuePersekolahData = payload;
}

export const SET_GUNDUKS_PERSEKOLAH = (state, guru) => {
    state.gunduksPersekolahData = guru;
}

export const SET_GUNDUKS_PERSEKOLAH_AKTIF = (state, guru) => {
    state.gunduksPersekolahDataAktif = guru;
}


export const SET_ERRORS_FORM_GURU = (state, errors) => {
    state.errors = errors;
}

export const UNSET_ERRORS_FORM_GURU = (state, errors) => {
    state.errors = [];
}

export const SET_GUKELS_PERSEKOLAH = (state, payload) => {
    state.gukelsPersekolahData = payload;
}

export const SET_SEMUA_GUKELS = (state, payload) => {
    state.semuaGukels = payload;
}

export const SET_MUGUS_PERSEKOLAH = (state, payload) => {
    state.mugusPersekolahData = payload;
}

export const SET_SEMUA_MUGUS = (state, payload) => {
    state.semuaMugus = payload;
}

export const SET_MUTENS_PERSEKOLAH = (state, payload) => {
    state.mutensPersekolahData = payload;
}

export const SET_SEMUA_MUTENS = (state, payload) => {
    state.semuaMutens = payload;
}
